import React from 'react'
import { isEmpty } from 'lodash/lang'
import Masonry from 'react-responsive-masonry'
import ExperienceItem from './ExperienceItem/ExperienceItem'
import styles from '../userCard.module.scss'
import { ReactComponent as NoInfoImage } from '../../../assets/images/experiense_stub.svg'

const Experience = ({ userCardData, userName }) => {
  const { experience_all: experience } = userCardData

  if (isEmpty(experience)) {
    return (
      <div className={styles.noInfo}>
        <NoInfoImage width={475} height={290} />
        <p>
          <b>{userName}</b> doesn’t have any experience yet.
        </p>
      </div>
    )
  } else {
    return (
      <Masonry columnsCount={1} gutter="16px">
        {experience?.map((experience, index) => (
          <ExperienceItem
            key={index}
            experience_type={experience.experience_type}
            title={experience.vesselName}
            period={experience.period}
            files={experience.files}
            items={experience.values}
          />
        ))}
      </Masonry>
    )
  }
}

export default Experience
